import lineColors from "./LineColors";
import lineTypes from "./LineTypes";

const availableLines = {
  place1_B2F: {
    itemtype: lineTypes.place,
    placename: "법학관 B2",
    buildingname: "법학관",
    previousplace: null,
    afterplace: "법학관 B1",
    placeinfo: "이마트, 커피빈",
    time: "운동장까지 30초",
    leftColor: lineColors.line1,
    rightColor: lineColors.line1,
  },
  place1_B1F: {
    itemtype: lineTypes.place,
    placename: "법학관 B1",
    buildingname: "법학관",
    previousplace: "법학관 B2",
    afterplace: "법학관 1F",
    placeinfo: "프린트",
    time: null,
    leftColor: lineColors.line1,
    rightColor: lineColors.line1,
  },
  place1_1F: {
    itemtype: lineTypes.place,
    placename: "법학관 1F",
    buildingname: "법학관",
    previousplace: "법학관 B1",
    afterplace: "법학관 2F",
    placeinfo: null,
    time: null,
    leftColor: lineColors.line1,
    rightColor: lineColors.line1,
  },
  place1_3F: {
    itemtype: lineTypes.place,
    placename: "법학관 3F",
    buildingname: "법학관",
    previousplace: "법학관 2F",
    afterplace: "법학관 4F",
    placeinfo: null,
    time: null,
    leftColor: lineColors.line1,
    rightColor: lineColors.line1,
  },
  place1_4F: {
    itemtype: lineTypes.place,
    placename: "법학관 4F",
    buildingname: "법학관",
    previousplace: "법학관 3F",
    afterplace: "법학관 5F",
    placeinfo: null,
    time: null,
    leftColor: lineColors.line1,
    rightColor: lineColors.line1,
  },
  place1_5F: {
    itemtype: lineTypes.place,
    placename: "법학관 5F",
    buildingname: "법학관",
    previousplace: "법학관 4F",
    afterplace: "법학관 옥상",
    placeinfo: null,
    time: null,
    leftColor: lineColors.line1,
    rightColor: lineColors.line1,
  },
  place1_6F: {
    itemtype: lineTypes.place,
    placename: "법학관 옥상",
    buildingname: "법학관",
    previousplace: "법학관 5F",
    afterplace: null,
    placeinfo: null,
    time: "종로02 정류장: 1분 15초",
    leftColor: lineColors.line1,
    rightColor: lineColors.line1,
  },

  place2_2F: {
    itemtype: lineTypes.place,
    placename: "수선관 2F",
    buildingname: "수선관",
    previousplace: "수선관 1F",
    afterplace: "수선관 3F",
    placeinfo: null,
    time: null,
    leftColor: lineColors.line2,
    rightColor: lineColors.line2,
  },
  place2_4F: {
    itemtype: lineTypes.place,
    placename: "수선관 4F",
    buildingname: "수선관",
    previousplace: "수선관 3F",
    afterplace: "수선관 5F",
    placeinfo: null,
    time: null,
    leftColor: lineColors.line2,
    rightColor: lineColors.line2,
  },
  place2_6F: {
    itemtype: lineTypes.place,
    placename: "수선관 6F",
    buildingname: "수선관",
    previousplace: "수선관 5F",
    afterplace: "수선관 7F",
    placeinfo: null,
    time: null,
    leftColor: lineColors.line2,
    rightColor: lineColors.line2,
  },
  place2_7F: {
    itemtype: lineTypes.place,
    placename: "수선관 7F",
    buildingname: "수선관",
    previousplace: "수선관 6F",
    afterplace: "수선관 8F",
    placeinfo: null,
    time: null,
    leftColor: lineColors.line2,
    rightColor: lineColors.line2,
  },
  place2_9F: {
    itemtype: lineTypes.place,
    placename: "수선관 9F",
    buildingname: "수선관",
    previousplace: "수선관 8F",
    afterplace: null,
    placeinfo: null,
    time: null,
    leftColor: lineColors.line2,
    rightColor: lineColors.line2,
  },

  place3_2F: {
    itemtype: lineTypes.place,
    placename: "수선관 별관 2F",
    buildingname: "수선관 별관",
    previousplace: "별관 1F",
    afterplace: "별관 3F",
    placeinfo: null,
    time: null,
    leftColor: lineColors.line3,
    rightColor: lineColors.line3,
  },
  place3_3F: {
    itemtype: lineTypes.place,
    placename: "수선관 별관 3F",
    buildingname: "수선관 별관",
    previousplace: "별관 2F",
    afterplace: "별관 4F",
    placeinfo: null,
    time: null,
    leftColor: lineColors.line3,
    rightColor: lineColors.line3,
  },
  place3_4F: {
    itemtype: lineTypes.place,
    placename: "수선관 별관 4F",
    buildingname: "수선관 별관",
    previousplace: "별관 3F",
    afterplace: "별관 5F",
    placeinfo: null,
    time: null,
    leftColor: lineColors.line3,
    rightColor: lineColors.line3,
  },
  place3_6F: {
    itemtype: lineTypes.place,
    placename: "수선관 별관 6F",
    buildingname: "수선관 별관",
    previousplace: "별관 5F",
    afterplace: "별관 7F",
    placeinfo: null,
    time: null,
    leftColor: lineColors.line3,
    rightColor: lineColors.line3,
  },
  place3_7F: {
    itemtype: lineTypes.place,
    placename: "수선관 별관 7F",
    buildingname: "수선관 별관",
    previousplace: "별관 6F",
    afterplace: "별관 8F",
    placeinfo: null,
    time: null,
    leftColor: lineColors.line3,
    rightColor: lineColors.line3,
  },
  place3_9F: {
    itemtype: lineTypes.place,
    placename: "수선관 별관 9F",
    buildingname: "수선관 별관",
    previousplace: "별관 8F",
    afterplace: "별관 10F",
    placeinfo: null,
    time: null,
    leftColor: lineColors.line3,
    rightColor: lineColors.line3,
  },
  place3_10F: {
    itemtype: lineTypes.place,
    placename: "수선관 별관 10F",
    buildingname: "수선관 별관",
    previousplace: "별관 9F",
    afterplace: null,
    placeinfo: null,
    time: null,
    leftColor: lineColors.line3,
    rightColor: lineColors.line3,
  },

  place4_1F_1: {
    itemtype: lineTypes.place,
    placename: "호암관 1F",
    buildingname: "호암관",
    previousplace: null,
    afterplace: "호암관 2F",
    placeinfo: null,
    time: "경영 1F까지 1분",
    leftColor: lineColors.line4,
    rightColor: lineColors.line4,
  },
  place4_1F_2: {
    itemtype: lineTypes.place,
    placename: "호암관 1F",
    buildingname: "호암관",
    previousplace: null,
    afterplace: "호암관 2F",
    placeinfo: null,
    time: "퇴계 2F까지 1분",
    leftColor: lineColors.line4,
    rightColor: lineColors.line4,
  },
  place4_2F: {
    itemtype: lineTypes.place,
    placename: "호암관 2F",
    buildingname: "호암관",
    previousplace: "호암관 1F",
    afterplace: "호암관 3F",
    placeinfo: "프린트",
    time: null,
    leftColor: lineColors.line4,
    rightColor: lineColors.line4,
  },
  place4_3F: {
    itemtype: lineTypes.place,
    placename: "호암관 3F",
    buildingname: "호암관",
    previousplace: "호암관 2F",
    afterplace: "호암관 4F",
    placeinfo: null,
    time: null,
    leftColor: lineColors.line4,
    rightColor: lineColors.line4,
  },
  place4_4F: {
    itemtype: lineTypes.place,
    placename: "호암관 4F",
    buildingname: "호암관",
    previousplace: "호암관 3F",
    afterplace: "호암관 5F",
    placeinfo: null,
    time: null,
    leftColor: lineColors.line4,
    rightColor: lineColors.line4,
  },
  place4_5F: {
    itemtype: lineTypes.place,
    placename: "호암관 5F",
    buildingname: "호암관",
    previousplace: "호암관 4F",
    afterplace: "호암관 6F",
    placeinfo: null,
    time: null,
    leftColor: lineColors.line4,
    rightColor: lineColors.line4,
  },
  place4_6F: {
    itemtype: lineTypes.place,
    placename: "호암관 6F",
    buildingname: "호암관",
    previousplace: "호암관 5F",
    afterplace: "호암관 7F",
    placeinfo: null,
    time: null,
    leftColor: lineColors.line4,
    rightColor: lineColors.line4,
  },
  place4_7F: {
    itemtype: lineTypes.place,
    placename: "호암관 7F",
    buildingname: "호암관",
    previousplace: "호암관 6F",
    afterplace: "호암관 8F",
    placeinfo: null,
    time: null,
    leftColor: lineColors.line4,
    rightColor: lineColors.line4,
  },
  place4_8F: {
    itemtype: lineTypes.place,
    placename: "호암관 8F",
    buildingname: "호암관",
    previousplace: "호암관 7F",
    afterplace: "호암관 9F",
    placeinfo: null,
    time: null,
    leftColor: lineColors.line4,
    rightColor: lineColors.line4,
  },
  place4_9F: {
    itemtype: lineTypes.place,
    placename: "호암관 9F",
    buildingname: "호암관",
    previousplace: "호암관 8F",
    afterplace: "호암관 10F",
    placeinfo: null,
    time: null,
    leftColor: lineColors.line4,
    rightColor: lineColors.line4,
  },
  place4_10F: {
    itemtype: lineTypes.place,
    placename: "호암관 10F",
    buildingname: "호암관",
    previousplace: "호암관 9F",
    afterplace: "호암관 11F",
    placeinfo: null,
    time: null,
    leftColor: lineColors.line4,
    rightColor: lineColors.line4,
  },
  place4_11F: {
    itemtype: lineTypes.place,
    placename: "호암관 11F",
    buildingname: "호암관",
    previousplace: "호암관 10F",
    afterplace: "호암관 12F",
    placeinfo: null,
    time: null,
    leftColor: lineColors.line4,
    rightColor: lineColors.line4,
  },
  place4_12F: {
    itemtype: lineTypes.place,
    placename: "호암관 12F",
    buildingname: "호암관",
    previousplace: "호암관 11F",
    afterplace: null,
    placeinfo: null,
    time: null,
    leftColor: lineColors.line4,
    rightColor: lineColors.line4,
  },

  place5_6F: {
    itemtype: lineTypes.place,
    placename: "퇴계인문관 6F",
    buildingname: "퇴계인문관",
    previousplace: "퇴계인문관 5F",
    afterplace: "퇴계인문관 7F",
    placeinfo: null,
    time: null,
    leftColor: lineColors.line5,
    rightColor: lineColors.line5,
  },
  place5_7F: {
    itemtype: lineTypes.place,
    placename: "퇴계인문관 7F",
    buildingname: "퇴계인문관",
    previousplace: "퇴계인문관 6F",
    afterplace: "퇴계인문관 8F",
    placeinfo: null,
    time: null,
    leftColor: lineColors.line5,
    rightColor: lineColors.line5,
  },
  place5_8F: {
    itemtype: lineTypes.place,
    placename: "퇴계인문관 8F",
    buildingname: "퇴계인문관",
    previousplace: "퇴계인문관 7F",
    afterplace: null,
    placeinfo: null,
    time: null,
    leftColor: lineColors.line5,
    rightColor: lineColors.line5,
  },

  place7_B4F: {
    itemtype: lineTypes.place,
    placename: "경영관 B4",
    buildingname: "경영관",
    previousplace: null,
    afterplace: "경영관 B3",
    placeinfo: "헬스장",
    time: null,
    leftColor: lineColors.line7,
    rightColor: lineColors.line7,
  },
  place7_B3F: {
    itemtype: lineTypes.place,
    placename: "경영관 B3",
    buildingname: "경영관",
    previousplace: "경영관 B4",
    afterplace: "경영관 B2",
    placeinfo: "카페, 편의점, 서점,\n꽃집, 미용실, 포토박스",
    time: null,
    leftColor: lineColors.line7,
    rightColor: lineColors.line7,
  },
  place7_B2F: {
    itemtype: lineTypes.place,
    placename: "경영관 B2",
    buildingname: "경영관",
    previousplace: "경영관 B3",
    afterplace: "경영관 B1",
    placeinfo: "식당, 카페",
    time: "다산 1F까지 1분 30초",
    leftColor: lineColors.line7,
    rightColor: lineColors.line7,
  },
  place7_B1F: {
    itemtype: lineTypes.place,
    placename: "경영관 B1",
    buildingname: "경영관",
    previousplace: "경영관 B2",
    afterplace: "경영관 1F",
    placeinfo: "프린트, 스터디룸",
    time: null,
    leftColor: lineColors.line7,
    rightColor: lineColors.line7,
  },
  place7_1F: {
    itemtype: lineTypes.place,
    placename: "경영관 1F",
    buildingname: "경영관",
    previousplace: "경영관 B1",
    afterplace: "경영관 2F",
    placeinfo: "프린트, 스터디룸",
    time: "호암 1F까지 1분",
    leftColor: lineColors.line7,
    rightColor: lineColors.line7,
  },
  place7_2F: {
    itemtype: lineTypes.place,
    placename: "경영관 2F",
    buildingname: "경영관",
    previousplace: "경영관 1F",
    afterplace: "경영관 3F",
    placeinfo: "라운지",
    time: "퇴계인문관 2F까지 1분",
    leftColor: lineColors.line7,
    rightColor: lineColors.line7,
  },
  place7_5F: {
    itemtype: lineTypes.place,
    placename: "경영관 5F",
    buildingname: "경영관",
    previousplace: "경영관 4F",
    afterplace: null,
    placeinfo: null,
    time: null,
    leftColor: lineColors.line7,
    rightColor: lineColors.line7,
  },

  place8_1F: {
    itemtype: lineTypes.place,
    placename: "교수회관 1F",
    buildingname: "교수회관",
    previousplace: null,
    afterplace: "교수회관 2F",
    placeinfo: "식당",
    time: null,
    leftColor: lineColors.line8,
    rightColor: lineColors.line8,
  },
  place8_2F: {
    itemtype: lineTypes.place,
    placename: "교수회관 2F",
    buildingname: "교수회관",
    previousplace: "교수회관 1F",
    afterplace: "교수회관 3F",
    placeinfo: null,
    time: null,
    leftColor: lineColors.line8,
    rightColor: lineColors.line8,
  },
  place8_3F: {
    itemtype: lineTypes.place,
    placename: "교수회관 3F",
    buildingname: "교수회관",
    previousplace: "교수회관 2F",
    afterplace: "교수회관 4F",
    placeinfo: null,
    time: null,
    leftColor: lineColors.line8,
    rightColor: lineColors.line8,
  },
  place8_4F: {
    itemtype: lineTypes.place,
    placename: "교수회관 4F",
    buildingname: "교수회관",
    previousplace: "교수회관 3F",
    afterplace: "교수회관 5F",
    placeinfo: null,
    time: null,
    leftColor: lineColors.line8,
    rightColor: lineColors.line8,
  },
  place8_5F: {
    itemtype: lineTypes.place,
    placename: "교수회관 5F",
    buildingname: "교수회관",
    previousplace: "교수회관 4F",
    afterplace: null,
    placeinfo: null,
    time: null,
    leftColor: lineColors.line8,
    rightColor: lineColors.line8,
  },

  place9_1F: {
    itemtype: lineTypes.place,
    placename: "중앙도서관 1F",
    buildingname: "중앙도서관",
    previousplace: null,
    afterplace: "중앙도서관 2F",
    placeinfo: "스터디룸, 카페",
    time: null,
    leftColor: lineColors.line9,
    rightColor: lineColors.line9,
  },
  place9_2F: {
    itemtype: lineTypes.place,
    placename: "중앙도서관 2F",
    buildingname: "중앙도서관",
    previousplace: "중앙도서관 1F",
    afterplace: "중앙도서관 3F",
    placeinfo: "스터디룸",
    time: null,
    leftColor: lineColors.line9,
    rightColor: lineColors.line9,
  },
  place9_3F: {
    itemtype: lineTypes.place,
    placename: "중앙도서관 3F",
    buildingname: "중앙도서관",
    previousplace: "중앙도서관 2F",
    afterplace: "중앙도서관 4F",
    placeinfo: "스터디룸, 프린트, 로봇커피",
    time: "6주 1F까지 2분 30초",
    leftColor: lineColors.line9,
    rightColor: lineColors.line9,
  },
  place9_4F: {
    itemtype: lineTypes.place,
    placename: "중앙도서관 4F",
    buildingname: "중앙도서관",
    previousplace: "중앙도서관 3F",
    afterplace: "중앙도서관 5F",
    placeinfo: "스터디룸",
    time: null,
    leftColor: lineColors.line9,
    rightColor: lineColors.line9,
  },
  place9_5F: {
    itemtype: lineTypes.place,
    placename: "중앙도서관 5F",
    buildingname: "중앙도서관",
    previousplace: "중앙도서관 4F",
    afterplace: null,
    placeinfo: "스터디룸",
    time: null,
    leftColor: lineColors.line9,
    rightColor: lineColors.line9,
  },

  place10_B4F: {
    itemtype: lineTypes.place,
    placename: "600주년 기념관 B4",
    buildingname: "600주년 기념관",
    previousplace: null,
    afterplace: "6주 B3",
    placeinfo: null,
    time: null,
    leftColor: lineColors.line10,
    rightColor: lineColors.line10,
  },
  place10_B3F: {
    itemtype: lineTypes.place,
    placename: "600주년 기념관 B3",
    buildingname: "600주년 기념관",
    previousplace: "6주 B4",
    afterplace: "6주 B2",
    placeinfo: null,
    time: null,
    leftColor: lineColors.line10,
    rightColor: lineColors.line10,
  },
  place10_B1F: {
    itemtype: lineTypes.place,
    placename: "600주년 기념관 B1",
    buildingname: "600주년 기념관",
    previousplace: "6주 B2",
    afterplace: "6주 1F",
    placeinfo: "식당, 우체국, 박물관",
    time: "국제관 2F까지 30초",
    leftColor: lineColors.line10,
    rightColor: lineColors.line10,
  },
  place10_1F: {
    itemtype: lineTypes.place,
    placename: "600주년 기념관 1F",
    buildingname: "600주년 기념관",
    previousplace: "6주 B1",
    afterplace: "6주 2F",
    placeinfo: "우리은행",
    time: "중도 3F까지 2분 30초\n국제관 2F까지 1분 30초",
    leftColor: lineColors.line10,
    rightColor: lineColors.line10,
  },
  place10_2F: {
    itemtype: lineTypes.place,
    placename: "600주년 기념관 2F",
    buildingname: "600주년 기념관",
    previousplace: "6주 1F",
    afterplace: "6주 3F",
    placeinfo: null,
    time: null,
    leftColor: lineColors.line10,
    rightColor: lineColors.line10,
  },
  place10_3F: {
    itemtype: lineTypes.place,
    placename: "600주년 기념관 3F",
    buildingname: "600주년 기념관",
    previousplace: "6주 2F",
    afterplace: "6주 4F",
    placeinfo: null,
    time: null,
    leftColor: lineColors.line10,
    rightColor: lineColors.line10,
  },
  place10_4F: {
    itemtype: lineTypes.place,
    placename: "600주년 기념관 4F",
    buildingname: "600주년 기념관",
    previousplace: "6주 3F",
    afterplace: "6주 5F",
    placeinfo: null,
    time: null,
    leftColor: lineColors.line10,
    rightColor: lineColors.line10,
  },
  place10_5F: {
    itemtype: lineTypes.place,
    placename: "600주년 기념관 5F",
    buildingname: "600주년 기념관",
    previousplace: "6주 4F",
    afterplace: "6주 6F",
    placeinfo: null,
    time: null,
    leftColor: lineColors.line10,
    rightColor: lineColors.line10,
  },
  place10_6F: {
    itemtype: lineTypes.place,
    placename: "600주년 기념관 6F",
    buildingname: "600주년 기념관",
    previousplace: "6주 5F",
    afterplace: null,
    placeinfo: null,
    time: null,
    leftColor: lineColors.line10,
    rightColor: lineColors.line10,
  },

  place11_B3F: {
    itemtype: lineTypes.place,
    placename: "국제관 B3",
    buildingname: "국제관",
    previousplace: null,
    afterplace: "국제관 B2",
    placeinfo: "주차장, 라운지",
    time: null,
    leftColor: lineColors.line11,
    rightColor: lineColors.line11,
  },
  place11_B2F: {
    itemtype: lineTypes.place,
    placename: "국제관 B2",
    buildingname: "국제관",
    previousplace: "국제관 B3",
    afterplace: "국제관 B1",
    placeinfo: "주차장, 프린트",
    time: null,
    leftColor: lineColors.line11,
    rightColor: lineColors.line11,
  },
  place11_B1F: {
    itemtype: lineTypes.place,
    placename: "국제관 B1",
    buildingname: "국제관",
    previousplace: "국제관 B2",
    afterplace: "국제관 1F",
    placeinfo: "주차장",
    time: null,
    leftColor: lineColors.line11,
    rightColor: lineColors.line11,
  },
  place11_2F: {
    itemtype: lineTypes.place,
    placename: "국제관 2F",
    buildingname: "국제관",
    previousplace: "국제관 1F",
    afterplace: "국제관 3F",
    placeinfo: "라운지, 프린트",
    time: "6주 1F까지 1분 30초\n6주 B1까지 30초",
    leftColor: lineColors.line11,
    rightColor: lineColors.line11,
  },
  place11_3F: {
    itemtype: lineTypes.place,
    placename: "국제관 3F",
    buildingname: "국제관",
    previousplace: "국제관 2F",
    afterplace: "국제관 4F",
    placeinfo: null,
    time: null,
    leftColor: lineColors.line11,
    rightColor: lineColors.line11,
  },
  place11_4F: {
    itemtype: lineTypes.place,
    placename: "국제관 4F",
    buildingname: "국제관",
    previousplace: "국제관 3F",
    afterplace: "국제관 5F",
    placeinfo: null,
    time: null,
    leftColor: lineColors.line11,
    rightColor: lineColors.line11,
  },
  place11_5F: {
    itemtype: lineTypes.place,
    placename: "국제관 5F",
    buildingname: "국제관",
    previousplace: "국제관 4F",
    afterplace: null,
    placeinfo: null,
    time: null,
    leftColor: lineColors.line11,
    rightColor: lineColors.line11,
  },

  place12_1F: {
    itemtype: lineTypes.place,
    placename: "학생회관 1F",
    buildingname: "학생회관",
    previousplace: null,
    afterplace: "학생회관 2F",
    placeinfo: null,
    time: null,
    leftColor: lineColors.line12,
    rightColor: lineColors.line12,
  },
  place12_2F: {
    itemtype: lineTypes.place,
    placename: "학생회관 2F",
    buildingname: "학생회관",
    previousplace: "학생회관 1F",
    afterplace: "학생회관 3F",
    placeinfo: "건강센터",
    time: null,
    leftColor: lineColors.line12,
    rightColor: lineColors.line12,
  },
  place12_3F: {
    itemtype: lineTypes.place,
    placename: "학생회관 3F",
    buildingname: "학생회관",
    previousplace: "학생회관 2F",
    afterplace: "학생회관 4F",
    placeinfo: "라운지",
    time: null,
    leftColor: lineColors.line12,
    rightColor: lineColors.line12,
  },
  place12_4F: {
    itemtype: lineTypes.place,
    placename: "학생회관 4F",
    buildingname: "학생회관",
    previousplace: "학생회관 3F",
    afterplace: "학생회관 5F",
    placeinfo: null,
    time: null,
    leftColor: lineColors.line12,
    rightColor: lineColors.line12,
  },
  place12_5F: {
    itemtype: lineTypes.place,
    placename: "학생회관 5F",
    buildingname: "학생회관",
    previousplace: "학생회관 4F",
    afterplace: null,
    placeinfo: null,
    time: null,
    leftColor: lineColors.line12,
    rightColor: lineColors.line12,
  },

  connect1: {
    itemtype: lineTypes.place,
    placename: "법학2F-수선3F",
    buildingname: "연결통로",
    previousplace: "법학관 2F",
    afterplace: "수선관 3F",
    placeinfo: null,
    time: null,
    leftColor: lineColors.line1,
    rightColor: lineColors.line2,
  },
  connect2: {
    itemtype: lineTypes.place,
    placename: "수선1F-별관1F",
    buildingname: "연결통로",
    previousplace: "수선관 1F",
    afterplace: "수선관 별관 1F",
    placeinfo: "별관1F 프린터",
    time: "셔틀/종로02 정류장까지 1분 40초",
    leftColor: lineColors.line2,
    rightColor: lineColors.line3,
  },
  connect3: {
    itemtype: lineTypes.place,
    placename: "수선8F-별관8F",
    buildingname: "연결통로",
    previousplace: "수선관 8F",
    afterplace: "수선관 별관 8F",
    placeinfo: null,
    time: "종로 02 정류장까지 1분 30초\n별관 5F까지 35초",
    leftColor: lineColors.line2,
    rightColor: lineColors.line3,
  },
  connect4: {
    itemtype: lineTypes.place,
    placename: "수선5F-별관5F",
    buildingname: "연결통로",
    previousplace: "수선관 5F",
    afterplace: "수선관 별관 5F",
    placeinfo: "별관 5F 카페, 프린트",
    time: "별관 8F까지 35초",
    leftColor: lineColors.line2,
    rightColor: lineColors.line3,
  },
  connect5: {
    itemtype: lineTypes.place,
    placename: "퇴2F-다2F-경4F",
    buildingname: "연결통로",
    previousplace: "퇴계관 2F",
    afterplace: "경영관 4F",
    placeinfo: "경영 4F 프린트, 라운지",
    time: "호암관 1F까지 1분\n경영관 2F까지 1분",
    leftColor: lineColors.line5,
    rightColor: lineColors.line7,
  },
  connect6: {
    itemtype: lineTypes.place,
    placename: "퇴계3F-다산3F",
    buildingname: "연결통로",
    previousplace: "퇴계관 3F",
    afterplace: "다산관 3F",
    placeinfo: "퇴계 3F 프린트",
    time: null,
    leftColor: lineColors.line5,
    rightColor: lineColors.line6,
  },
  connect7: {
    itemtype: lineTypes.place,
    placename: "퇴계4F-다산4F",
    buildingname: "연결통로",
    previousplace: "퇴계관 4F",
    afterplace: "다산관 4F",
    placeinfo: "다산 4F 프린트, 라운지",
    time: null,
    leftColor: lineColors.line5,
    rightColor: lineColors.line6,
  },
  connect8: {
    itemtype: lineTypes.place,
    placename: "퇴계5F-다산5F",
    buildingname: "연결통로",
    previousplace: "퇴계관 5F",
    afterplace: "다산관 5F",
    placeinfo: null,
    time: null,
    leftColor: lineColors.line5,
    rightColor: lineColors.line6,
  },
  connect9: {
    itemtype: lineTypes.place,
    placename: "다산1F-경영3F",
    buildingname: "연결통로",
    previousplace: "다산관 1F",
    afterplace: "경영관 3F",
    placeinfo: null,
    time: "경영 B2까지 1분 30초",
    leftColor: lineColors.line6,
    rightColor: lineColors.line7,
  },
  connect10: {
    itemtype: lineTypes.place,
    placename: "6주B2-국제1F",
    buildingname: "연결통로",
    previousplace: "6주B2",
    afterplace: "국제관 1F",
    placeinfo: "6주 B2 극장\n국제 1F 라운지, 카페",
    time: null,
    leftColor: lineColors.line10,
    rightColor: lineColors.line11,
  },
};

export default availableLines;
